<!--  -->
<template>
  <div>
    <div class="phone_box">
      <div v-if="id === 1">
        <div class="phone_content">
          <div v-if="activeName === 'text'" class="writtenwords" v-html="text" />
          <div v-if="activeName === 'img'" class="img_box">
            <img v-if="temporary" class="pic_img" :src="temporary">
          </div>
        </div>

        <div class="phone_contentone">
          <div v-if="activeName === 'news'" class="newview">
            <div v-if="priewarr.length === 1">
              <div class="title_box">{{ title }}</div>
              <div class="imaetext">
                <div class="decrtionsview">{{ describetion }}</div>
                <img v-if="testsrc" style="width:50px;height:50px;object-fit: contain;" :src="testsrc">
              </div>
            </div>
            <div v-else>
              <div v-for="items,indexr in priewarr" :key="indexr" :class="[indexr === 0 ? 'updatabox' : 'updatabox1']">
                <span :class="[indexr === 0?'spanbox':'spanbox1']">
                  {{ items.title }}
                </span>
                <div :style="{backgroundImage: 'url('+items.picurl+')'}" :class="[indexr === 0?'backrbox':'backrbox1']" />
              </div>
            </div>
          </div>
        </div>
        <div class="phone_contentone">
          <div v-if="activeName === 'miniprogrampage'" class="imagetext">
            <div class="image_title">{{ typename }}</div>
            <div class="image_title">{{ name }}</div>
            <div class="imaetext">
              <img v-if="programimg" style="width:50px;height:50px;object-fit: contain;" :src="programimg">
            </div>
          </div>
        </div>
        <div class="phone_contentone">
          <div v-if="activeName === 'miniprogram_official'" class="imagetext">
            <div v-for="item,index in selectOffical" :key="index" class="Pchooser_box">
              <div class="Pchooser_allbox">
                <img v-if="item.weappiconurl!='' && item.weappiconurl!= null" :src="item.weappiconurl" alt="" srcset="" style="width:30px;border-radius: 50%;">
                <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:30px;border-radius: 50%;">
                <!-- <div class="titlew_box">{{ item.title }}</div> -->
                <div class="Ptitlew_box">{{ item.des_1 }}</div>
              </div>
              <div class="Pdaser">{{ item.title }}</div>
              <div class="Pcahrw_box">
                <img :src="item.thumburl" alt="" srcset="" style="width:100%;height: 158px;">
              </div>
              <div style="margin:6px 0px">{{ item.remark }}</div>
              <div>{{ item.created_at_str }}</div>
              <div class="Pline" />
              <!-- <div style="color:#252525;margin-top: 5px;">
                <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
                  <el-avatar :size="15" :src="item.sender_avatar" @error="errorHandler">
                    <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
                  </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
                  <div v-else style="margin-left: 10px;width: 70px;height: 27px;" />
                </span>
                <div style="margin-bottom: 10px;">
                  <el-tag type="warning">{{ item.type_text }}</el-tag>
                </div>
                <div style="display: flex;">
                  <el-tag> {{ item.created_at_str }}</el-tag>
                </div>
                <div style="font-size: 12px;margin-top: 10px;" class="copy_box">
                  <el-tag v-if="item.miniprogram_no!=''" type="success">{{ item.miniprogram_no }}</el-tag>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div v-else class="phone_content">
        <!-- {{ arr }} -->
        <div>{{ templateName }}</div>
        <div class="phone_data">{{ createdAtText }}</div>
        <div class="phone_contentse">
          <div v-for="(itemw,idxr) in arr" :key="idxr" class="phone_item">
            {{ itemw.title }}: <span :style="{color:itemw.color}">{{ itemw.value }}</span>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      id: null,
      activeName: null,
      text: null,
      temporary: null,

      title: null,
      describetion: null,
      testsrc: null,

      arr: [],
      createdAtText: null,
      templateName: null,
      // obj: {
      //   a: 1
      // }
      // optionsr: [{
      //   name: 666
      // }, {
      //   name: 777
      // }]
      name: null,
      programimg: null,
      typename: '',
      priewarr: [],
      selectOffical: []
    }
  },
  created() {
    // this.optionsr.forEach((item) => {
    //   this.$set(item, 'tow', false)
    //   // item.tow = false
    // })
  },
  mounted() {

  },
  methods: {
    send(val, id) {
      this.id = id
      console.log('val', val, id)
      if (id === 1) {
        this.activeName = val.msg_type
        if (val.msg_type === 'text') {
          console.log('val.msg_data.text.content', val.msg_data.text.content)
          this.text = val.msg_data.text.content
        }
        if (val.msg_type === 'img') {
          this.temporary = val.msg_data.img.url
        }
        if (val.msg_type === 'news') {
          if (val.msg_data.news.articles.length === 1) {
            console.log('3333', val.msg_data.news.articles.length)
            this.title = val.msg_data.news.articles[0].title
            this.describetion = val.msg_data.news.articles[0].description
            this.testsrc = val.msg_data.news.articles[0].picurl
            this.priewarr = val.msg_data.news.articles
          } else {
            this.priewarr = val.msg_data.news.articles
          }
        }
        // eslint-disable-next-line eqeqeq
        if (val.msg_type == 'miniprogrampage') {
          console.log('222')
          this.name = val.msg_data.miniprogrampage.title
          this.programimg = val.msg_data.miniprogrampage.thumb_media_url
          this.typename = val.msg_data.miniprogrampage.appid_type
        }
        // eslint-disable-next-line eqeqeq
        if (val.msg_type == 'miniprogram_official') {
          console.log('111')
          this.selectOffical = []
          this.selectOffical.push(val.msg_data.miniprogram_official)
        }
      } else {
        console.log('val1111', val)
        // this.arr = val.variableValue
        this.createdAtText = val.createdAtText
        this.templateName = val.templateName
        this.arr = val.preview
      }
    },
    errorHandler() {}
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.phone_box{
  background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  margin-left: 100px;
  position: relative;
}
.phone_content{
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
  padding: 10px 25px 14px 11px;
  box-sizing: border-box;
}
.phone_contentone{
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
}
.phone_data{
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.phone_item{
  margin-bottom: 10px;
}
.add_template{
  display: flex;
}
.img_box{
  height: 80px;
}
.pic_img{
  max-height: 100%;
}

.imagetext{
  padding: 10px;
    box-sizing: border-box;
}
.newview{
  padding: 10px;
  max-height: 340px;
  overflow: hidden;
  overflow-y: auto;
}
.newview::-webkit-scrollbar {
  display: none;
}
.imaetext{
      display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.phone_data{
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.updatabox{
  height: 100px;
  width: 220px;
  text-align: center;
  line-height: 100px;
  position: relative;
}
.updatabox1{
    position: relative;
    height: 72px;
      width: 200px;
    border: 1px solid #f3f3f3;
    padding: 0 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.backrbox{
    width: 200px;
    height: 100%;
  background-color: #e1e1e1;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.backrbox1{
    position: absolute;
    background-color: #e1e1e1;
        background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    top: 9px;
    right: 17px;
    width: 50px;
    height: 50px;
}
.spanbox{
  position: absolute;
  left: 15px;
  top: 30px;
  z-index: 9;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 187px;
  text-align: left;
}
.spanbox1{
  position: inherit;
  left: 0;
  top: 0;
  z-index: 9;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.decrtionsview{
  margin-top:5px;
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.title_box{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 187px;
}
.writtenwords{
      white-space: pre-wrap;
}
.Pchooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 400px;
  overflow-y: auto;
}
.Pchooser_box{
  width: 100%;
  height: 75%;
  box-sizing: border-box;
  margin-right: 30px;
}
.Ptitlew_box{
  margin-left: 5px;
  /* width: 150px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Pcahrw_box{
  /* margin-top: 10px; */
}
.Pline{
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.Pdaser{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 227px; */
  margin-top:5px;
  max-height: 35px;
  margin-bottom: 5px;
}
.Pdaserr{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  margin-top:5px;
  max-height: 34px;
}
.Pcopy_box{
  display: flex;
  align-items: center;
}
.Pcopy_icon{
  margin-left: 5px;
}
@media (max-width: 768px) {
  .phone_box{
    margin:0px;
  }
}
</style>
